import React from 'react'
import { Navigate } from 'react-router-dom'
import RegisterStepperView from 'src/views/auth/register/RegisterStepperView'
import BankResult from 'src/views/auth/register/BankResult'
import ResetPassword from 'src/views/auth/resetPassword/ResetPasswordStepper'
import LoginView from 'src/views/auth/LoginView'
import NotFoundView from 'src/views/errors/NotFoundView'
import NavBarLessLayout from 'src/layouts/NavBarLessLayout'
import ProfileView from 'src/views/account/ProfileView'
import PasswordChangeView from 'src/views/account/PasswordChangeView'
import DashboardView from 'src/views/reports/DashboardView'
import ProductListView from 'src/views/product/ProductListView'
import SettingsView from 'src/views/settings/SettingsView'
import Notifications from 'src/views/notifications'
import Chats from 'src/views/chats'
import Users from 'src/views/users'
import AffiliateMarketing from 'src/views/affiliateMarketing'
import Stages from 'src/views/stage'
import Discount from '../views/discount'
import Sales from '../views/sales'
import Referee from '../views/referee'
import Scholarship from '../views/scholarship'
import Exams from '../views/exams'
import UnderDevelopment from '../components/UnderDevelopment'
import LoadingPage from '../components/LoadingPage'
import Courses from '../views/courses'
import Extend from '../views/extend/index'
import Events from '../views/events/index'
// import UserPackage from '../views/exams/UserPackages'
// import Receipt from '../components/bankPortal/Receipt'
import Receipt from '../components/bankPortal/Receipt'

export const defaultRoutes = (props) => {
  const { user = {} } = props
  if (!user.userId && !user.init) {
    return [
      {
        path: '/',
        element: <NavBarLessLayout {...props} />,
        children: [
          {
            path: 'login',
            element: <LoginView />,
          },
          {
            path: 'register',
            element: <RegisterStepperView />,
          },
          {
            path: 'resetpassword',
            element: <ResetPassword />,
          },
          {
            path: '404',
            element: <NotFoundView />,
          },
          {
            path: '/',
            element: <Navigate to="/login" />,
          },
          {
            path: '*',
            element: <Navigate to="/login" />,
          },
          {
            name: 'BankResult',
            path: 'BankResult',
            element: <BankResult />,
          },
        ],
      },
    ]
  } if (user.init) {
    return [{
      path: '*',
      element: <LoadingPage />,
    }]
  }
  return [
    {
      path: '*',
      element: <Navigate to="/app" />,
    },
    {
      name: 'BankResult',
      path: 'BankResult',
      element: <BankResult />,
    },
  ]
}

// if(!window.localStorage.getItem("IS_REGISTER")) {
// return [
// {
// path: '*',
// element: <Navigate to="/app" />,
// },
// {
// path: 'register',
// element: <RegisterStepperView />,
// },
// ]
// }
// return [
// {
// path: '*',
// element: <Navigate to="/app" />,
// },
// ]

export const dashboardRoutes = [
  {
    name: 'profileEdit',
    path: 'profile/edit',
    element: <ProfileView />,
  },
  {
    name: 'profileChangePassword',
    path: 'profile/change-password',
    element: <PasswordChangeView />,
  },
  {
    // name: 'coursesUser',
    path: 'courses/admin/*',
    element: <Courses.Admin />,
  },
  {
    // name: 'coursesUser',
    path: 'courses/user/*',
    element: <Courses.User />,
  },
  {
    // name: 'stages',
    path: 'stages/*',
    element: <Stages.Admins />,
  },
  {
    name: 'users',
    path: 'users/*',
    element: <Users.Admins />,
  },
  {
    name: 'customers',
    path: 'customers/*',
    element: <Users.Customers />,
  },
  {
    name: 'dashboard',
    path: 'dashboard',
    element: <DashboardView />,
  },
  {
    name: 'products',
    path: 'products',
    element: <ProductListView />,
  },
  {
    name: 'settings',
    path: 'settings',
    element: <SettingsView />,
  },
  {
    name: 'notificationAdmin',
    path: 'notifications/admin/*',
    element: <Notifications.Admin />,
  },
  {
    name: 'notificationUser',
    path: 'notifications/user/*',
    element: <Notifications.User />,
  },
  {
    name: 'chatsAdmin',
    path: 'chats/admin/*',
    element: <Chats.Admin />,
  },
  {
    name: 'chatUser',
    path: 'chats/user/*',
    element: <Chats.User />,
  },

  {
    // name: 'affiliateMarketingAdmin',
    path: 'affiliateMarketing/admin/*',
    element: <AffiliateMarketing.Admin />,
  },
  {
    name: 'events',
    path: 'events/admin/*',
    element: <Events.Admin />,
  },
  {
    name: 'events',
    path: 'events/user/*',
    element: <Events.User />,
  },
  {
    // name: 'affiliateMarketingUser',
    path: 'affiliateMarketing/user/*',
    element: <AffiliateMarketing.User />,
  },

  {
    name: 'discounts',
    path: 'discounts/*',
    element: <Discount />,
  },
  {
    name: 'referee',
    path: 'referee/*',
    element: <Referee />,
  },
  {
    name: 'scholarship',
    path: 'scholarship/*',
    element: <Scholarship.User />,
  },
  {
    name: 'extend',
    path: 'extend/*',
    element: <Extend.Admin />,
  },
  // {
  // name: 'userPackage',
  // path: 'userPackage/*',
  // element: <UserPackage />,
  // },
  {
    name: 'scholarships',
    path: 'scholarships/*',
    element: <Scholarship.Admin />,
  },
  {
    name: 'examsUser',
    path: 'exams/user/*',
    element: <Exams.User />,
  },
  {
    name: 'examsAdmin',
    path: 'exams/admin/*',
    element: <Exams.Admin />,
  },
  {
    name: 'examsAdmin',
    path: 'exams/packages/*',
    // element: <Exams.Packages />,
    element: <Exams.Packages />,
  },
  {
    name: 'underDevelopment',
    path: 'underDevelopment',
    element: <UnderDevelopment />,
  },
  {
    path: 'payment/:payId/success',
    element: <Receipt />,
  },
  {
    path: 'payment/:payId/failed',
    element: <Receipt />,
  },
  {
    name: 'sales',
    path: 'sales',
    element: <Sales />,
  },
  {
    name: 'BankResult',
    path: 'BankResult',
    element: <BankResult />,
  },
]
